import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_WorkHub_Tab.scss';
import { _className, LL_H_C, openContent } from '@nu-art/thunderstorm-frontend';
import { exists } from '@nu-art/ts-common';
import { ModuleFE_WorkHub } from '../../../../_module/index.js';
const onTabMouseDown = (e, tabId) => {
    if (e.button !== 1) //Only take into account middle mouse button
        return;
    e.stopPropagation();
    ModuleFE_WorkHub.tabs.remove(tabId);
};
const onTabClick = (e, tabId) => {
    e.stopPropagation();
    ModuleFE_WorkHub.tabs.select(tabId);
};
const onTabRightClick = (e, tab) => {
    const workHubItem = ModuleFE_WorkHub.workHubItem.getByKey(tab.itemKey);
    if (!workHubItem)
        return;
    workHubItem.openTabMenu(e, tab);
};
export const Component_WorkHub_Tab = (props) => {
    const className = _className('c__work-hub-tab', props.selected && 'selected');
    const editMode = props.tab.renderArgs?.editMode === true;
    return _jsxs(LL_H_C, { className: className, "data-edit-mode": editMode ? 'true' : undefined, onMouseUp: e => onTabMouseDown(e, props.tab.id), onClick: e => onTabClick(e, props.tab.id), onContextMenu: e => onTabRightClick(e, props.tab), children: [exists(props.tab.tag) && _jsx("div", { className: 'c__work-hub-tab__tag', ...openContent.tooltip.bottom('work-hub-tab-tooltip', () => _jsx(_Fragment, { children: props.tab.tagLabel ?? props.tab.label }), { offset: 5 }), children: props.tab.tag }), props.tab.label] });
};
//# sourceMappingURL=Component_WorkHub_Tab.js.map